
export class SongToStrengthenDTO {
  constructor (songId, songTitle, artistName, strength) {
    this.songId = songId;
    this.songTitle = songTitle;
    this.artistName = artistName;
    this.strength = strength;
  }
}
